import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ApplyButton from "../../../components/actions/ApplyButton";
import { formatLinkString } from "../../../components/utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faClock, faBriefcase, faUsers } from "@fortawesome/free-solid-svg-icons";
import "./styleCard.css"; // Assurez-vous que les styles sont présents

const JobCardList = ({ job }) => {
  const { t } = useTranslation();

  return (
    <div className="card-job-list-modern hover-up">
      <div className="d-flex align-items-center flex-wrap flex-md-nowrap h-100">
        
        {/* COLONNE 1 : LOGO */}
        <div className="job-list-logo-wrapper">
          <Link to={`/job/${job?.slug}/details/`}>
            <div className="image-box">
              <img
                src={
                  job?.image
                    ? formatLinkString(job?.image)
                    : "/assets/imgs/page/homepage2/logo1.jpg"
                }
                alt={job?.title}
              />
            </div>
          </Link>
        </div>

        {/* COLONNE 2 : CONTENU PRINCIPAL */}
        <div className="job-list-content flex-grow-1 ms-md-4 mt-3 mt-md-0">
          <div className="d-flex justify-content-between align-items-start">
             <h5 className="mb-1">
                <Link to={`/job/${job?.slug}/details/`} className="text-dark fw-bold job-title-link">
                    {job?.title}
                </Link>
             </h5>
             {/* Badge Mobile (visible seulement sur petit écran) */}
             <div className="d-md-none">
                {job?.closed && <span className="badge bg-danger">Fermé</span>}
             </div>
          </div>

          {/* Meta Infos (Lieu, Date, Type) */}
          <div className="footer-stat" title={t("textNberAppl")}>
                    <FontAwesomeIcon icon={faUsers} className="me-1 text-primary" />
                    {job.submitted} <span className="d-none d-sm-inline">Candidats</span>
          </div>
          <div className="text-muted small mb-2 d-flex flex-wrap gap-3">
             <span className="d-flex align-items-center">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1 text-primary" />
                {job?.city?.name || "Ville N/A"}, {job?.country?.name || "Pays N/A"}
             </span>
             <span className="d-flex align-items-center">
                <FontAwesomeIcon icon={faBriefcase} className="me-1 text-primary" />
                {job?.type}
             </span>
             <span className="d-flex align-items-center">
                <FontAwesomeIcon icon={faClock} className="me-1 text-primary" />
                {moment(job?.created_at).fromNow()}
             </span>
          </div>
    

          {/* Description courte (tronquée) */}
          <div 
            className="job-description-preview text-muted mb-3"
            dangerouslySetInnerHTML={{ __html: job?.description || '' }}
          ></div>

          {/* Tags / Compétences */}
          <div className="d-flex flex-wrap gap-2">
            {Array.isArray(job?.skills) && job.skills.slice(0, 3).map((skill) => (
                <span key={skill?.id} className="badge bg-light text-dark border fw-normal">
                    {skill?.name}
                </span>
            ))}
          </div>
        </div>

        {/* COLONNE 3 : ACTIONS & STATS (Droite) */}
        <div className="job-list-actions mt-3 mt-md-0 ms-md-4 text-md-end d-flex flex-column justify-content-between" style={{minWidth: '160px'}}>
            
            <div className="mb-3 d-none d-md-block">
                {job?.closed ? (
                    <span className="badge bg-danger px-3 py-2 rounded-pill">{t("jobExpired")}</span>
                ) : (
                    <span className="badge bg-success-soft text-success px-3 py-2 rounded-pill">Actif</span>
                )}
            </div>

            <div className="mb-2 text-muted small" title={t("textNberPlaces")}>
                <strong className="text-dark">{job?.required || 1}</strong> Postes ouverts
            </div>

            <div className="mt-auto">
                {job?.closed ? (
                    <button className="btn btn-secondary btn-sm w-100 disabled">Fermé</button>
                ) : (
                    /* Le bouton Postuler */
                    <div className="d-grid">
                        <ApplyButton
                            key={job?.id + "btn"}
                            hideModal={true}
                            hideButton={false}
                            jobId={job?.id}
                            job={job}
                            // On peut passer une classe custom si ApplyButton l'accepte
                            className="btn btn-primary btn-sm w-100 fw-bold"
                        />
                    </div>
                )}
                <div className="text-end mt-2">
                    <Link to={`/job/${job?.slug}/details/`} className="small text-primary text-decoration-underline">
                        Voir détails
                    </Link>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default JobCardList;